let decoder;

export const escapeHtml = (html) => {
  decoder = decoder || document.createElement('div')
  decoder.innerHTML = html
  return decoder.textContent
}